// chatHeaderStyles.js
import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  header: {
    color: 'white',
    boxShadow: 'none',
    position: 'sticky',
    top: 0,
    zIndex: 1100,
    width: '100%'
  },
  headerContent: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    borderBottom:
      '1px solid ' +
      (theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_stroke.main),
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    minHeight: 48
  },
  backButton: {
    marginRight: theme.spacing(1),
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main
  },

  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4)
  },
  // Cores para os avatares (podem ser movidas para um arquivo de estilos mais genérico se usadas em vários lugares)
  purple: {
    backgroundColor: '#9c27b0'
  },
  grey: {
    backgroundColor: '#9e9e9e'
  },
  blue: {
    backgroundColor: '#2196f3'
  },
  cyan: {
    backgroundColor: '#00bcd4'
  },
  menuButton: {
    marginLeft: 'auto',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main
  },
  confirmDeleteOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000
  },
  confirmDeleteModal: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    padding: theme.spacing(3),
    borderRadius: theme.spacing(1),
    width: '80%',
    maxWidth: 400
  },
  confirmDeleteButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    gap: theme.spacing(1)
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'hidden',
    marginLeft: theme.spacing(1)
  },
  userName: {
    fontSize: '1rem',
    marginLeft: theme.spacing(1),
    flexGrow: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: '600',
    lineHeight: 1.2,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  participantsList: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '0.75rem',
    marginTop: 2
  },

  dialogTitle: {
    color: theme.palette.blue_300.main
  },

  menuItem: {
    display: 'flex',
    gap: '8px',
    fontSize: '0.875rem',
    margin: '6px',
    padding: '4px 14px',
    borderRadius: '6px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  }
}))
